import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4.5 7.5V7v.5zM.646 7.146a.5.5 0 000 .708l3.182 3.182a.5.5 0 10.708-.708L1.707 7.5l2.829-2.828a.5.5 0 10-.708-.708L.646 7.146zM9 0v2.5h1V0H9zM4.5 7H1v1h3.5V7zM9 2.5A4.5 4.5 0 014.5 7v1A5.5 5.5 0 0010 2.5H9z" fill="currentColor" /></svg>);